var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// store для управление глобальными состояниями приложения
import { 
// action,
observable, runInAction, } from 'mobx';
export const stateAppStore = observable({
    stateOrder: 0,
    stateMobileMenu: 0,
    //   error: null,
});
export const stateAppActions = {
    setAppStateOrder: (newState) => __awaiter(void 0, void 0, void 0, function* () {
        runInAction(() => {
            stateAppStore.stateOrder = newState;
        });
    }),
};
